export const defaultState = {
    qualityCheckInProgress: false,
    qualityReport: null,
    qualityCheckFailed: false
  }
  